<template lang="pug">
    .col-span-6(:style='style')
        label.block.text-sm.font-medium.text-gray-700(
            :for="'field_' + parameter.id",
            :class="{ 'required': parameter['required'] }")
            | {{ parameter.name }}
        .mt-1.relative.rounded-md.shadow-sm
            .absolute.inset-y-0.left-0.pl-3.flex.items-center.pointer-events-none
                span(class='text-gray-500 sm:text-sm')
            input(:type='type'
                class='block w-full'
                +' pr-12 border-gray-300'
                +' rounded-md focus:ring-indigo-500'
                +' focus:border-indigo-500 sm:text-sm'
                :placeholder='placeholder'
                :name="'field_' + parameter.id"
                :id="'field_' + parameter.id"
                v-model="inputValue"
                :class="{ 'form-error': error }"
                @input='handleInput')
            .absolute.inset-y-0.right-0.flex.items-center
                select(class='focus:ring-indigo-500'
                +' focus:border-indigo-500'
                +' sm:text-sm h-full py-0 pl-2 pr-7'
                +' border-transparent bg-transparent'
                +' text-gray-500 rounded-md'
                    v-model='selectedUnit'
                    @change='handleUnitChange'
                    :name="'field_' + parameter.id")
                    option(v-for='unit in units', :value='unit.id')
                        | {{ unit.name }}
        p(class='mt-2 p-1 rounded text-sm text-red-500 bg-gray-100'
            v-if='error')
            | {{ error.message || 'Поле обязательно для заполнения' }}
</template>

<script>

export default {
    name: 'ItemFormGroupParameterUnits',

    props: {
        parameter: {
            type: Object,
        },

        value: {
            type: Object,
            default: () => {
                return {
                    value: '',
                    unit: 0,
                }
            },
        },

        error: {
            type: [Object, Boolean],
        },
    },

    data() {
        return {
            placeholder: '',
            type: '',
            style: '',
            units: [],
            selectedUnit: 0,
            inputValue: '',
        }
    },

    computed: {
        cValue() {
            return {
                value: this.inputValue,
                unit: this.selectedUnit,
            }
        },

        extra() {
            return (this.parameter.hasOwnProperty('extra_serialized')) ?
                this.parameter.extra_serialized :
                [{id: 0, name: 'Нет'}]
        }
    },

    mounted() {
        if (this.extra) {
            this.placeholder = this.extra['placeholder']
            this.type = this.extra['type']
            this.style = this.extra['style']
            // this.units = JSON.parse(this.extra['units'])
            this.units = this.extra['units']
            this.inputValue = this.value.value
            this.selectedUnit = this.value.unit || this.units[0].id
        }
    },

    methods: {
        handleInput($event) {
            this.inputValue = $event.target.value
            this.$emit('input', this.cValue)
        },

        handleUnitChange() {
            if (this.inputValue) {
                this.$emit('input', this.cValue)
            }
        },
    },

}
</script>
